import { render, staticRenderFns } from "./VerPorArea.vue?vue&type=template&id=493cb581&"
import script from "./VerPorArea.vue?vue&type=script&lang=js&"
export * from "./VerPorArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports